var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectangleRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 491.531,
    height: 304.534,
    viewBox: "0 0 491.531 304.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M4.306,1.279,47.921,238.34C50.13,238.34,256,164.215,256,166.424l235.531,47.941c0,2.209-.071,85.712,0,88.154l-.356,1.236-.917,1.328-1.376.729L4,305.62a4,4,0,0,1-4-4L.508,4.87A3.5,3.5,0,0,1,4.306,1.279Z",
    transform: "translate(0 -1.279)",
    fill: "#dd1623"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleRed);
export default __webpack_public_path__ + "static/media/rectangle_red.fb8df56cb81d2686b0cba748e9c477a7.svg";
export { ForwardRef as ReactComponent };